<template>
    <section id="gallery" class="section">
        <div id="gallery-anchor" style="position: relative; top: -100px; height: 0; width: 0;"></div>
        <a-divider orientation="left" class="section-title"><b style="font-size: 28px;">Examples</b></a-divider>
        <a-carousel :beforeChange="beforeChange" :afterChange="afterChange">
            <a slot="customPaging" slot-scope="props">
                <div class="story-title" :class="props.i === focus ? 'active' : ''">
                    {{stories[props.i].title}}
                </div>
            </a>
            <Story v-for="story in stories" :key="story.title"
                   :story="story">
            </Story>
        </a-carousel>
    </section>
</template>

<script>
    import Story from "@/components/Gallery/Story";

    export default {
        name: 'gallery',
        components: {Story},
        data() {
            return {
                focus: 0,
                stories: [],
            };
        },
        methods: {
            beforeChange() {
                this.focus = -1;
            },
            afterChange(a) {
                console.log(a);
                this.focus = a;
            },
        },
        mounted() {
          fetch('./source/demoList.json')
            .then(res => res.json())
            .then(demoList => demoList.forEach(demo => this.stories.push(demo)));
        }
    }
</script>

<style>
    .section {
        margin-bottom: 50px;
    }

    .section-title {
        text-align: center;
        flex: 0 1 85%;
        font-size: 28px;
    }

    .story-title {
        position: relative;
        left: -110px;
        width: 100px;
        top: 0;
        margin: 5px 0;
        transition: all 0.5s ease;
        color: grey;
        border-top: solid 3px grey;
    }

    .story-title:hover {
        color: #8bc7ff;
        border-top: solid 3px #8bc7ff;
    }

    .story-title.active {
        color: #1890ff;
        border-top: solid 3px #1890ff;
    }
</style>
